// @team Commerce Experience
import flow from 'lodash/flow';
import React from 'react';

import FlashSalesPopup from '../../features/Popups/pages/FlashSales';
import { withApolloContext } from '../../utils/apollo';

const FlashSalesPage = () => <FlashSalesPopup cross />;

const Cmp = flow(withApolloContext({ ssr: true }))(FlashSalesPage);

Cmp.displayName = 'Popup/FlashSales';

export default Cmp;
